(function () {
  function initCombo(root) {
    if (!root || root.dataset.comboBound) return;
    root.dataset.comboBound = "1";

    var currentVariants = [];
    try {
      currentVariants = JSON.parse(root.querySelector("[data-combo-current-variants]").textContent);
    } catch (e) { currentVariants = []; }

    function fmt(cents) {
      var n = (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return "N$" + n;
    }

    function fmtShort(cents) {
      return "N$" + Math.round(cents / 100);
    }

    function currentVariantId() {
      var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (input && input.value) return Number(input.value);
      return currentVariants.length ? currentVariants[0].id : null;
    }

    function currentPrice() {
      var id = currentVariantId();
      for (var i = 0; i < currentVariants.length; i++) {
        if (currentVariants[i].id === id) return currentVariants[i].price;
      }
      return currentVariants.length ? currentVariants[0].price : 0;
    }

    function pickedItems() {
      var items = [];
      root.querySelectorAll("[data-combo-item]").forEach(function (cb) {
        if (!cb.checked) return;
        var id, price;
        if (cb.dataset.variant) {
          id = Number(cb.dataset.variant);
          price = Number(cb.dataset.price);
        } else {
          var sel = cb.closest(".combo-b__row").querySelector("[data-combo-variant]");
          if (!sel) return;
          var opt = sel.options[sel.selectedIndex];
          id = Number(sel.value);
          price = Number(opt.dataset.price);
        }
        items.push({ id: id, price: price });
      });
      return items;
    }

    function perItemOff(n) {
      if (n >= 3) return 10000;
      if (n >= 2) return 5000;
      return 0;
    }

    function recompute() {
      var items = pickedItems();
      var n = 1 + items.length;
      var subtotal = currentPrice();
      items.forEach(function (it) { subtotal += it.price; });
      var per = perItemOff(n);
      var discount = per * n;
      var total = subtotal - discount;

      root.querySelector("[data-combo-count]").textContent = n + (n === 1 ? " item" : " items");
      var was = root.querySelector("[data-combo-was]");
      var totalEl = root.querySelector("[data-combo-total]");
      var save = root.querySelector("[data-combo-save]");
      var hint = root.querySelector("[data-combo-hint]");
      var buy = root.querySelector("[data-combo-buy]");
      var cp = root.querySelector("[data-combo-current-price]");
      if (cp) cp.textContent = fmt(currentPrice());

      totalEl.textContent = fmt(total);
      if (discount > 0) {
        was.hidden = false;
        was.textContent = fmt(subtotal);
        save.hidden = false;
        save.textContent = "You save " + fmt(discount) + " (" + fmtShort(per) + " off each item)";
        buy.disabled = false;
        buy.textContent = "Add combo to cart — " + n + " items for " + fmt(total);
      } else {
        was.hidden = true;
        save.hidden = true;
        buy.disabled = true;
        buy.textContent = "Tick at least 1 item to start saving";
      }

      if (hint) {
        if (n === 2) {
          hint.hidden = false;
          hint.textContent = "Add 1 more item and the discount doubles to N$100 off each!";
        } else {
          hint.hidden = true;
        }
      }
    }

    function refreshCartBubble() {
      try {
        fetch("/?sections=cart-icon-bubble").then(function (r) { return r.json(); }).then(function (sections) {
          var bubble = document.getElementById("cart-icon-bubble");
          if (bubble && sections["cart-icon-bubble"]) bubble.innerHTML = sections["cart-icon-bubble"];
          document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        });
      } catch (e) { /* best-effort */ }
    }

    root.querySelector("[data-combo-buy]").addEventListener("click", function () {
      var btn = this;
      var items = pickedItems().map(function (it) { return { id: it.id, quantity: 1 }; });
      var cid = currentVariantId();
      if (cid) items.unshift({ id: cid, quantity: 1 });
      if (items.length < 2) return;
      btn.classList.add("is-busy");
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return r.json();
      }).then(function () {
        refreshCartBubble();
        window.location.href = "/cart";
      }).catch(function () {
        btn.classList.remove("is-busy");
      });
    });

    root.addEventListener("change", recompute);
    document.addEventListener("change", function (e) {
      if (!root.contains(e.target)) setTimeout(recompute, 150);
    });
    recompute();
  }

  function initAll() {
    document.querySelectorAll(".combo-b").forEach(initCombo);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", initAll);
})();